import React from "react";
import { Reveal } from "@/components/Reveal";
import { LeafField } from "@/components/LeafDecor";

// Eyebrow label + title used on subpages
export function SectionHeader({ eyebrow, title, subtitle, center = false, light = false }) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""} mb-12`}>
      {eyebrow && (
        <span className={`inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4 ${light ? "text-gold" : "text-olive"}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`font-display text-4xl sm:text-5xl leading-[1.05] ${light ? "text-cream" : "text-forest"}`}>
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base ${light ? "text-cream/70" : "text-muted-foreground"}`}>{subtitle}</p>}
    </div>
  );
}

// Simple hero band for interior pages
export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-36 pb-20 overflow-hidden grain" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-forest/80" />
        </>
      )}
      {!image && <LeafField />}
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          {eyebrow && (
            <span className={`inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4 ${image ? "text-gold" : "text-olive"}`}>
              {eyebrow}
            </span>
          )}
          <h1 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-3xl ${image ? "text-cream" : "text-forest"}`}>
            {title}
          </h1>
          {subtitle && (
            <p className={`mt-5 text-lg max-w-2xl ${image ? "text-cream/80" : "text-muted-foreground"}`}>{subtitle}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
